import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import request from "./auth/request"
import "./assets/scss/index.scss"
Vue.prototype.request = request

// import AlloyFinger from 'alloyfinger'
// import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
// Vue.use(AlloyFingerPlugin, {
//   AlloyFinger
// })

import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import 'element-ui/lib/theme-chalk/index.css';
import { Autocomplete } from 'element-ui'
Vue.use(Autocomplete);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import './assets/font/font.css';

import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui'
Vue.use(ElementUI);

import moment from 'moment'
Vue.prototype.$moment = moment;
moment.suppressDeprecationWarnings = true;
Vue.filter('format', function (val, arg) {
  if (!val) return;
  val = val.toString()
  return moment(val).format(arg)
})

import label from "@/components/label";
Vue.component('b-form-group2', label)

Vue.config.productionTip = false
import ECharts from "vue-echarts";
import theme from './theme.json'
ECharts.registerTheme('ovilia-green', theme)


import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/markLine";
import "echarts/lib/component/graphic";
Vue.component("v-chart", ECharts);

//导出pdf插件
import vueToPdf from 'vue-to-pdf';
Vue.use(vueToPdf);

//vue 视频插件
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

import pdf from 'vue-pdf'
Vue.use(pdf)
import wx from "weixin-js-sdk";
Vue.prototype.$wx = wx;
Vue.prototype.$utils = {
  /**
   * 时间格式转换
   * @param {需要转换的值} val
   * @param {转换的格式，默认年月日} format
   * @returns
   */
  DimeFormat(val, format = "yyyy-mm-dd") {
    let date = new Date(val);
    let y = date.getFullYear();
    let m = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let mm = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let datatimes = "";
    if (format == "yyyy-mm-dd") {
      datatimes = y + "-" + m + "-" + d;
    } else if (format == "yy-mm") {
      datatimes = y + "-" + m;
    } else if (format == "mm-dd") {
      datatimes = m + "-" + d;
    } else if (format == "yyyy-mm-dd-hh-mm") {
      datatimes = y + "-" + m + "-" + d + " " + h + ":" + mm;
    } else if (format == "yyyy-mm-dd-hh") {
      datatimes = y + "/" + m + "/" + d + " " + h;
    }
    return datatimes;
  }
}


import VueAMap from 'vue-amap'; //高得地图
Vue.use(VueAMap);

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {ak: 'qUWEev3hSvaVbeTW9W5dwPn6vhlsTzz1'})
VueAMap.initAMapApiLoader({
  key: '8f5cbe7e703e50ecdfc8d6bbdd80cb68',
  plugin: [
    "AMap.Autocomplete", //输入提示插件
    "AMap.PlaceSearch", //POI搜索插件
    "AMap.Scale", //右下角缩略图插件 比例尺
    "AMap.OverView", //地图鹰眼插件
    "AMap.ToolBar", //地图工具条
    "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    "AMap.PolyEditor", //编辑 折线多，边形
    "AMap.CircleEditor", //圆形编辑器插件
    "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
    'AMap.Geocoder'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
Array.prototype.min = function () {
  var min = this[0];
  var len = this.length;
  for (var i = 1; i < len; i++) {
    if (this[i] < min) {
      min = this[i];
    }
  }
  return min;
}
Array.prototype.max = function () {
  var max = this[0];
  var len = this.length;
  for (var i = 1; i < len; i++) {
    if (this[i] > max) {
      max = this[i];
    }
  }
  return max;
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
